import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import About from "../views/About.vue";
import Contact from "../views/Contact.vue";
import CaseStudy from "../views/CS_strategic_design.vue";
import CaseStudy_sayhi from "../views/CS_sayhi.vue";
import CaseStudy_xweather from "../views/CS_xweather.vue";
import CaseStudy_AIUX from "../views/CS_AIUX_process.vue";
import CaseStudy_TA from "../views/CS_TA.vue";
import LoginPortal from "../views/Login.vue";
import Stats from "../views/Stats.vue";
import NotFound from "../views/NotFound.vue";
import routerRender from "../components/routerRender.vue";
import i18n from "../i18n";

const routes = [
  {
    path: "/",
    redirect: `/${i18n.global.locale.value || "en"}`, // If NOT i18.local defined => set to english
  },
  {
    path: "/:lang",
    component: routerRender,
    props: true,
    children: [
      {
        path: "",
        name: "home",
        component: Home,
        props: true,
      },
      {
        path: "about",
        name: "about",
        component: About,
        props: true,
      },
      {
        path: "contact",
        name: "contact",
        component: Contact,
        props: true,
      },
      {
        path: "login",
        name: "login",
        component: LoginPortal,
        meta: { hideNavFooter: true },
        props: true,
      },
      {
        path: "case-strategic-design",
        name: "stretegic-design",
        component: CaseStudy,
        props: true,
        meta: { requiresAuth: false },
      },
      {
        path: "case-sayhi",
        name: "case-sayhi",
        component: CaseStudy_sayhi,
        props: true,
        meta: { requiresAuth: false },
      },
      {
        path: "case-xweather",
        name: "case-xweather",
        component: CaseStudy_xweather,
        props: true,
        meta: { requiresAuth: false },
      },
      {
        path: "case-aiux",
        name: "case-aiux",
        component: CaseStudy_AIUX,
        props: true,
        meta: { requiresAuth: false },
      },
      {
        path: "case-talentAlchemy",
        name: "case-talentAlchemy",
        component: CaseStudy_TA,
        props: true,
        meta: { requiresAuth: false },
      },
      {
        path: "stats",
        name: "stats",
        component: Stats
      },
      // Cacth 404
      {
        path: ":catchAll(.*)",
        name: "404",
        component: NotFound,
        props: true,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,

  // Scroll to top on route change with a delay to allow for transition effects
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ left: 0, top: 0 })
      }, 600)
    })
  },
});

// Auth guard moved to src/main.js to centralize navigation logic (i18n + auth + logging)
export default router;
